import { render, staticRenderFns } from "./PriceOne.vue?vue&type=template&id=1d310a68&scoped=true"
import script from "./PriceOne.vue?vue&type=script&lang=js"
export * from "./PriceOne.vue?vue&type=script&lang=js"
import style0 from "./PriceOne.vue?vue&type=style&index=0&id=1d310a68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d310a68",
  null
  
)

export default component.exports